import { Link } from "react-router-dom";

export const Logo = ({ size = 40, withText = true, testId = "site-logo" }) => (
  <Link
    to="/"
    className="group inline-flex items-center gap-3"
    data-testid={testId}
    aria-label="Goldmap EA home"
  >
    <img
      src="/goldmap-logo.png"
      alt="Goldmap EA logo"
      width={size}
      height={size}
      className="rounded-full"
      style={{ border: "1px solid rgba(255,255,255,0.25)" }}
    />
    {withText ? (
      <span className="font-display text-base font-extrabold uppercase tracking-tight text-white sm:text-lg">
        Goldm<span style={{ color: "var(--gm-red)" }}>a</span>p
        <span className="ml-1 text-xs font-bold" style={{ color: "var(--gm-muted-2)" }}>
          EA
        </span>
      </span>
    ) : null}
  </Link>
);
